import { render, staticRenderFns } from "./core-details-form.component.vue?vue&type=template&id=7466b6e5"
import script from "./core-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./core-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports